import { Spacer } from '@pypestream/design-system';
import { useTranslation } from '@pypestream/translations';
import { useFormContext } from 'react-hook-form';

import { useManagerCtxSelector } from '../../../xstate/app.xstate';
import { OutputProjectFormType, ReturnFormType } from '../..';
import {
  ProjectDescriptionField,
  ProjectIconField,
  ProjectNameField,
} from '../create-project-flow';
import { ProjectFormButtons } from './project-form-buttons';
import { ProjectTitles } from './project-titles';

export type ProjectInfoPropsType = {
  nextStep: (formData?: Partial<OutputProjectFormType>) => void;
};

export const ProjectInfo = ({ nextStep }: ProjectInfoPropsType) => {
  const { organizationId } = useManagerCtxSelector((ctx) => ({
    organizationId: ctx.selectedOrgId,
  }));

  const [t] = useTranslation();

  const form = useFormContext();

  const { handleSubmit, register } = form;

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <ProjectTitles
        step="project-info"
        title={
          t('manager/projects:createProject.step1.title', {
            defaultValue: 'Create a project',
          }) || ''
        }
      />
      <Spacer size="xlarge" />
      <ProjectNameField _form={form as unknown as ReturnFormType} required />
      <Spacer size="xlarge" />
      <ProjectDescriptionField
        _form={form as unknown as ReturnFormType}
        {...register('description')}
      />
      <Spacer size="xlarge" />
      <ProjectIconField
        form={form as unknown as ReturnFormType}
        uploadProps={{
          accountId: organizationId,
          label:
            t('manager/projects:createProject.step1.icon', {
              defaultValue: 'Project Icon (optional)',
            }) || '',
        }}
      />
      <Spacer size="xlarge" />
      <ProjectFormButtons
        step="project-info"
        nextStep={handleSubmit((data) => nextStep(data))}
      />
    </form>
  );
};
